import { render, staticRenderFns } from "./documentTypeManagement.vue?vue&type=template&id=5b9b9586&scoped=true&"
import script from "./documentTypeManagement.vue?vue&type=script&lang=js&"
export * from "./documentTypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b9586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9b9586')) {
      api.createRecord('5b9b9586', component.options)
    } else {
      api.reload('5b9b9586', component.options)
    }
    module.hot.accept("./documentTypeManagement.vue?vue&type=template&id=5b9b9586&scoped=true&", function () {
      api.rerender('5b9b9586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/documentTypeManagement.vue"
export default component.exports